import React from 'react';
export default (function (props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "cloud-ui-nav-menu-heading"
  }, props.children);
});